<template>
  <div class="cat-list">
    <div class="drap_down">
      <i class="nav_icon"></i>
      <span class="hidden-title">{{TLang('京东优选分类','my')}}</span>
    </div>
    <div
      ref="$listwrap"
      class="list-wrap"
      :class="{showMoreHeigth: showMore}"
      @mouseleave.prevent="showMore = false;"
    >
      <div v-if="dfLang === 'en-US'">
        <div>
          <div class="drap_down_item"
               v-for="(cat,i) in catList"
               :key="`9+${i}`"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="99"
                :name="cat.name"
                :onChange="onChange"
                :lang="'ch'"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <!-- 排序方式写死：3,2,4,3,2,3,3,3,3,2 -->
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i < 3"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 0 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="0"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 3 && i < 5"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 3 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="3"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 5 && i < 9"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 5 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="5"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 9 && i < 12"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 9 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="9"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 12 && i < 14"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 12 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="12"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 14 && i < 17"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 14 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="14"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 17 && i < 20"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 17 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="17"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 20 && i < 23"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 20 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="20"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 23 && i < 26"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 23 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="23"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
        <div class="drap_down_item">
          <div
              v-for="(cat,i) in catList"
              v-show="i >= 26 && i < 28"
              :key="`9+${i}`"
              :class="['text'+hash[i], i > 26 && 'long']"
          >
            <Category
                :id="cat.id"
                :i="i"
                :x="26"
                :name="cat.name"
                :onChange="onChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { unionFlag } from '@utils';
import Category from '../Category';
export default {
  components: {
    Category,
  },
  props: {
    catList: {
      type: Array,
      default: function(){
        return [];
      },
    },
    onChange: Function,
  },
  data(){
    return {
      showMore: false,
      union: unionFlag(),
      right_content_top: 0,
      hash: [4,2,2,4,2,2,2,2,2,2,4,2,2,4,4,2,4,4,2,2,4,2,4,4,2,4,4,3], // 写死的分类字数
      dfLang: this.getCookie('df_lang')
    };

  },
  methods: {
     getCookie(name) {
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      }
    }
};
</script>

<style lang="less">
.cat-list{
  width: 220px;
  margin-top: -44px;
  position: relative;
  margin-left: 20px;
  .drap_down{
    width: 220px;
    background: url('./bookNavBg.png') center center no-repeat;
    background-size: 100% auto;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    line-height: 44px;
    display: flex;
    justify-content: left;
    align-items: center;
    padding-left: 52px;
    box-sizing: border-box;
    .nav_icon{
      width: 16px;
      height: 14px;
      margin-right: 10px;
      background: url('./navIcon.png') center center no-repeat;
      background-size: 100% auto;
    }
  }
  .list-wrap{
    height: 455px;
    box-shadow:0px 0px 16px 0px rgba(0,0,0,0.1);
    position: relative;
    .drap_down_item {
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        display: flex;
        padding-left: 15px;
        padding-right: 10px;
        align-items: center;
        position: relative;
        white-space: nowrap;
        line-height: 36px;
        cursor: pointer;
        &::after {
          content: "";
          display: inline-block;
          height: 1px;
          width: 100%;
          background: #f7f7f7;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        &:hover{
          background: #ECF5FD;
        }
      }
      .rigth_content{
        display: block;
        left: 100%;
        position: absolute;
        z-index: 11;
        top: 0px;
        width: 680px;
        background: #fff;
        padding: 30px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        height: auto;
        &:hover{
          cursor: pointer;

        }
        p {
          font-size: 18px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: left;
          position: relative;
          &:after {
            content: "";
            display: inline-block;
            width: 630px;
            height: 1px;
            background: #f0f0f0;
            position: absolute;
            bottom: -10px;
            left: 0;
          }
        }
      }
      .showMore{
        position: absolute;
        bottom: 0;
        text-align: center;
        width: 100%;
        height:44px;
        background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 61%,rgba(255,255,255,1) 100%);
        line-height: 44px;
        color: #3D96E2;
        i{
          position: absolute;
          left: 62px;
          transform: rotate(180deg);
        }
        i.down{
          top: 3px;
        }
        i.up{
          top: -2px;
        }
        &:hover{
          cursor: pointer;
        }
      }
    }

    .showMoreHeigth{
      height: auto;
      overflow-y: visible;
    }
  }
</style>